import { TitleObjectType, PopularTitle, SeenDetailTitle } from '@/interfaces/titles';
import { SeenSeason } from '@/helpers/watchlist-helper';

export enum TitleListSource {
	USER = 'user',
}
export enum TitleListVisibility {
	USER = 'user',
}

// list of valid watchlist names
export enum TitleListName {
	WATCHLIST = 'watchlist',
	SEENLIST = 'seenlist',
	LIKELIST = 'likelist',
	DISLIKELIST = 'dislikelist',
	MORELIST = 'morelist',
}

export const DEFAULT_TITLE_LIST_NAME: TitleListName = TitleListName.WATCHLIST;

// response with not fully quantified title information
export type TitleListResponse = Array<TitleList>;

export interface TitleListFull {
	items: PopularTitle[];
	page: number;
	page_size: number;
	total_pages: number;
	total_results: number;
}

// response with popular titles inside
export interface TitleListFullResponse {
	id: number;
	name: TitleListName;
	owner_best_effort_id: string;
	source: TitleListSource;
	titles_full: TitleListFull;
	titles: TitleListTitle[];
	visibility: TitleListVisibility;
	isAtEndOfList?: boolean;
	items?: PopularTitle[];
}

export interface WatchNextFullResponse {
	items: PopularTitle[];
}

export interface TitleList {
	id: number;
	name: TitleListName;
	owner_best_effort_id: string;
	source: TitleListSource;
	titles: TitleListTitle[];
	visibility: TitleListVisibility;
}

export interface TitleListTitle {
	created_at: string;
	index: number;
	object_id: number;
	object_type: TitleObjectType;
	seen_details?: SeenDetailTitle;
	seen_seasons?: SeenSeason[];
	title_list_id: number; // references to TitleList object
}
